import { ReactNode } from "react";

interface LoadingContainerStyledProps {
  children: ReactNode;
}

export const LoadingContainerStyled = ({
  children,
}: LoadingContainerStyledProps) => {
  return (
    <div className="w-full min-h-[150px] h-full flex justify-center items-center p-5">
      {children}
    </div>
  );
};
